/**
 * Frontend mirror of backend/src/utils/email-domain.util.ts — used ONLY for
 * the advisory "use your work email" nudge on the signup email step (see
 * Slack's own signup form, which shows the same non-blocking suggestion).
 * This is NOT a security boundary: the backend's copy is what actually
 * gates the one-workspace-per-company-domain check, this one only decides
 * whether to render a banner. Kept as a separate small list rather than an
 * API round-trip, since a UI hint has no need to be authoritative.
 */
const FREE_EMAIL_DOMAINS = new Set([
  'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.co.in', 'yahoo.co.uk',
  'ymail.com', 'outlook.com', 'hotmail.com', 'hotmail.co.uk', 'live.com',
  'msn.com', 'icloud.com', 'me.com', 'mac.com', 'aol.com',
  'protonmail.com', 'proton.me', 'tutanota.com', 'tutanota.de', 'tuta.io',
  'zoho.com', 'gmx.com', 'gmx.net', 'mail.com', 'yandex.com', 'yandex.ru',
  'rediffmail.com', 'qq.com', '163.com', '126.com', 'sina.com',
  'naver.com', 'daum.net', 'web.de', 'inbox.com', 'fastmail.com',
]);

export function isFreeEmailDomain(email: string): boolean {
  const domain = email.toLowerCase().trim().split('@')[1] || '';
  return FREE_EMAIL_DOMAINS.has(domain);
}
